import api, { setToken } from '../index';

/** Одноразові анонси кабінету, які треба показати цій людині просто зараз. */
export function noticesPending(data) {
  return api.get('/notices/pending', setToken(data.token));
}

/** Підтвердити показ анонсу — більше він не прийде. */
export function noticeSeen(data) {
  return api.post(`/notices/${data.key}/seen`, {}, setToken(data.token));
}

export function noticesPreview(data) {
  return api.get('/notices/preview', setToken(data.token));
}
